export function CtaFilledFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 8a3 3 0 013-3h12a3 3 0 013 3v1.959a3 3 0 01-1.28 2.457l-.688.482.415.208a1 1 0 01.26 1.601L18.414 16l1.293 1.293a1 1 0 01-1.414 1.414L17 17.414l-1.293 1.293a1 1 0 01-1.601-.26l-.778-1.556-2.238 1.567A3 3 0 019.37 19H6a3 3 0 01-3-3V8zm14.875 6.302a.426.426 0 00-.11-.682l-5.147-2.573a.426.426 0 00-.571.571l2.573 5.146c.13.26.477.317.682.111l2.573-2.573z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
